"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typography = {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;"
};
exports.default = typography;
//# sourceMappingURL=typography.js.map